import { type FC } from 'react'

import { useUnit } from 'effector-react'

import {
  $hasMore,
  $stats,
  fetchPriorityMassMessagesPageFx,
} from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/priorityMassMessagesStats.ts'

import { StatsTable } from './components/StatsTable.tsx'
import { priorityStatsTableColumns } from './components/priorityStatsTableColumns.tsx'

export interface Props {}

export const PriorityStatsTable: FC<Props> = () => {
  const hasMore = useUnit($hasMore)
  const stats = useUnit($stats)
  const isLoading = useUnit(fetchPriorityMassMessagesPageFx.pending)

  return (
    <StatsTable
      columns={priorityStatsTableColumns}
      data={stats}
      onLoadMore={fetchPriorityMassMessagesPageFx}
      canLoadMore={hasMore && !isLoading}
      isLoading={isLoading}
      isLoadingMore={isLoading && !!stats.length}
    />
  )
}
